// extracted by css-extract-rspack-plugin
export default {"container":"container-npfwTE","name":"name-t8Vonh"};